import React, { useContext } from 'react';
import { arrayOf, number, shape, string } from 'prop-types';
import classNames from 'classnames/bind';
import { Col } from '@thd-olt-component-react/core-ui';
import { Histogram } from '@thd-olt-component-react/histogram';
import styles from './rating-detailed.module.scss';

const cx = classNames.bind(styles);

export const RatingDetailed = ({
  averageOverallRating,
  notRecommendedCount,
  ratingDistribution,
  recommendedCount,
  totalReviewCount
}) => {

  const formatHistogramData = (data) => {
    return data.map((element) => {
      return {
        ratingValue: element.RatingValue,
        count: element.Count
      };
    });
  };

  const getRecommendationPercentage = (recommended, notRecommended) => {
    const recommendedInt = parseInt(recommended, 10);
    const notRecommendedInt = parseInt(notRecommended, 10);
    return String(Math.round((recommendedInt / (recommendedInt + notRecommendedInt)) * 100));
  };

  if (!(averageOverallRating && notRecommendedCount && ratingDistribution && recommendedCount && totalReviewCount)) {
    return null;
  }

  return (
    <div className={cx('rating-detailed')}>
      <div className={cx('rating-detailed__header')}>
        <Col xs="6">
          <span className={cx('rating-detailed__header--bold')}>
            {averageOverallRating}
          </span>
          <div>
            out of {totalReviewCount} reviews
          </div>
        </Col>
        <Col xs="6">
          <span>
            <span className={cx('rating-detailed__header--bold')}>
              {getRecommendationPercentage(
                recommendedCount, notRecommendedCount
              )}%
            </span>
            recommend this store
          </span>
        </Col>
      </div>
      <div className={cx('rating-detailed__histogram')}>
        <Histogram
          ratings={formatHistogramData(ratingDistribution)}
          totalReviews={totalReviewCount}
        />
      </div>
    </div>
  );
};

RatingDetailed.propTypes = {
  notRecommendedCount: number.isRequired,
  recommendedCount: number.isRequired,
  averageOverallRating: string.isRequired,
  ratingDistribution: arrayOf(shape({
    RatingValue: number,
    Count: number
  })).isRequired,
  totalReviewCount: number.isRequired
};

RatingDetailed.displayName = 'RatingDetailed';
